import { View } from "react-native";
import { useTailwind } from "tailwind-rn";

import InventoryText from "../../components/InventoryText";
import VariantOptions from "../../components/VariantOptions";
import { Inventory } from "../../types";

type Props = {
  options: string[];
  inventory: Inventory;
};

export default function CombinationInfo({ options, inventory }: Props) {
  const tailwind = useTailwind();
  return (
    <View style={tailwind("flex-1 items-center my-6")}>
      <VariantOptions options={options} />
      <View style={tailwind("mt-2")}>
        <InventoryText inventory={inventory} />
      </View>
    </View>
  );
}
